import { useCallback, useState } from 'react';
var isTouchDevice = navigator.maxTouchPoints || 'ontouchstart' in document.documentElement;
const useGraphTouchEvents = (isAbleToZoom, setZoomStartTime, setZoomEndTime, setZoom, setTimeAsNumber = false) => {
    const [touchPoints, setTouchPoints] = useState([]);
    const [startZoom, setStartZoom] = useState(false);
    const setZoomStart = useCallback((time) => setTimeAsNumber
        ? setZoomStartTime(time)
        : setZoomStartTime(time + ''), [setTimeAsNumber, setZoomStartTime]);
    const setZoomEnd = useCallback((time) => setTimeAsNumber
        ? setZoomEndTime(time)
        : setZoomEndTime(time + ''), [setTimeAsNumber, setZoomEndTime]);
    const onTouchStart = useCallback(e => {
        if (!isAbleToZoom || !e || !e.activeLabel) {
            return;
        }
        if (isTouchDevice && touchPoints.length === 1) {
            const minTime = Math.min(touchPoints[0], +e.activeLabel);
            const maxTime = Math.max(touchPoints[0], +e.activeLabel);
            setZoomStart(minTime);
            setZoomEnd(maxTime);
            setTouchPoints([minTime, maxTime]);
        }
        else if (isTouchDevice) {
            setStartZoom(true);
            setZoomStart(+e.activeLabel);
            setTouchPoints([+e.activeLabel]);
        }
        else {
            setStartZoom(true);
            setZoomStart(+e.activeLabel);
        }
    }, [
        isAbleToZoom,
        setZoomStart,
        setZoomEnd,
        touchPoints.length,
        setTouchPoints,
        setStartZoom
    ]);
    const onTouchMove = useCallback(e => {
        if (!isAbleToZoom || !e || !e.activeLabel) {
            return;
        }
        if (isTouchDevice && touchPoints.length === 2) {
            const isNewTimeMin = Math.abs(+e.activeLabel - touchPoints[0]) <
                Math.abs(+e.activeLabel - touchPoints[1]);
            const minTime = isNewTimeMin ? +e.activeLabel : touchPoints[0];
            const maxTime = isNewTimeMin ? touchPoints[1] : +e.activeLabel;
            setZoomStart(minTime);
            setZoomEnd(maxTime);
            setTouchPoints([minTime, maxTime]);
        }
        else if (!isTouchDevice && startZoom) {
            setZoomEnd(+e.activeLabel);
        }
    }, [
        isAbleToZoom,
        setZoomStart,
        setZoomEnd,
        touchPoints,
        setTouchPoints,
        startZoom
    ]);
    const onTouchEnd = useCallback(() => {
        if (isTouchDevice) {
            setTouchPoints([]);
        }
        setStartZoom(false);
        if (isAbleToZoom)
            setZoom();
    }, [isAbleToZoom, setTouchPoints, setStartZoom, setZoom]);
    return {
        startZoom,
        onTouchStart,
        onTouchMove,
        onTouchEnd
    };
};
export default useGraphTouchEvents;
